// admin/src/components/ConfirmDialog.jsx
import React from 'react';

/**
 * ConfirmDialog - Reusable confirmation dialog
 * 
 * Props:
 * - isOpen: boolean
 * - title: string
 * - message: string
 * - onConfirm: function
 * - onCancel: function
 * - confirmText: string (default: "Confirm")
 * - cancelText: string (default: "Cancel")
 * - danger: boolean (makes confirm button red)
 */
export function ConfirmDialog({ 
  isOpen, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = false
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 400 }}
      >
        <div className="modal-header">
          <h2>{title}</h2>
        </div>

        <div className="modal-body">
          <p style={{ margin: 0, color: '#374151' }}>{message}</p>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={`btn ${danger ? 'btn--danger' : 'btn--primary'}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;